/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EmailType {
    DEFAULT = 'Default',
    PERSONAL = 'Personal',
    BUSINESS = 'Business',
}
